import config from '../config'

var intercom

if (!window.Intercom) {
    intercom = function() {
        if (window.Intercom.c) {
            window.Intercom.c(arguments)
        } else {
            // window.Intercom was replaced after script load
            window.Intercom(...arguments)
        }
    }
    intercom.q = []
    intercom.c = (args) => intercom.q.push(args)
    window.Intercom = intercom

    if (config.intercom.appId) {
        var script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://widget.intercom.io/widget/' + config.intercom.appId
        document.body.appendChild(script)
    }
} else {
    intercom = window.Intercom
    intercom('reattach_activator')
    intercom('update', intercomSettings)
}

export default intercom


// WEBPACK FOOTER //
// ./lib/core/intercom.js